import gql from 'graphql-tag';

import type { BriefStatus, BriefType } from 'src/data/brief';
import { executeGqlQuery } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendQueryBriefArgs } from 'src/types/backend';

import { BRIEF_FROM_LIST_FRAGMENT } from './schema';

const QUERY = gql`
  query BriefStatus($id: ID!) {
    brief(id: $id) {
      ...BriefFromList
    }
  }
  ${BRIEF_FROM_LIST_FRAGMENT}
`;

interface ResultItem {
  id: ID;
  type: BriefType;
  status: BriefStatus;
  errors?: string; // JSON
}

type Variables = BackendQueryBriefArgs;

export const queryBriefStatus = async (variables: Variables): Promise<ResultItem | undefined> => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables,
  });

  return getSingleProp<ResultItem>(result.data);
};
